import { useContext } from 'react';
import { LocationContext } from '../contexts/LocationContext';
import { ButtonLinkType } from '../graphql-fragments/ButtonLink';
import { BackgroundColorTheme } from '../templates/Page';
import { getUrlFromVersatileLink } from './sanity';
import { checkUrlsMatch } from './utils';

export function areSameDay(date1: Date, date2: Date): boolean {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
}

export function simplifyToLightOrDarkTheme(
  theme?: BackgroundColorTheme,
): BackgroundColorTheme | undefined {
  if (!theme) {
    return theme;
  }
  return (
    {
      panoramic: 'panoramic',
      evening: 'panoramic',
      sunset: 'panoramic',
      moonlit: 'starlit',
      starlit: 'starlit',
    } as const
  )[theme];
}

export function isEntryActive(entry: ButtonLinkType) {
  const location = useContext(LocationContext);

  if (location && checkUrlsMatch(location.pathname, getUrlFromVersatileLink(entry))) {
    return true;
  }

  return false;
}
